import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8e86438"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Today ")
const _hoisted_2 = {
  class: "timeline-colheader border border-gray-300 w-1",
  rowspan: "2"
}
const _hoisted_3 = {
  key: 0,
  class: "timeline-colheader border border-gray-300",
  colspan: "7"
}
const _hoisted_4 = { class: "timeline-row" }
const _hoisted_5 = { class: "timeline-row timeline-row-hover cursor-pointer w-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "font-black pl-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "absolute left-10 right-0 truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ios_arrow_back = _resolveComponent("ios-arrow-back")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_ios_arrow_forward = _resolveComponent("ios-arrow-forward")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_ios_arrow_down = _resolveComponent("ios-arrow-down")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button_group, { class: "mb-5" }, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          ghost: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
      _ctx.$emit(
        'updateBasedate',
        _ctx.localdayjs( _ctx.theFirstDate)
          .add(-_ctx.showWeek * 7, 'days')
          .toDate()
      )
    )),
          disabled: 
      !_ctx.showBeforeToday &&
      _ctx.localdayjs( _ctx.theFirstDate).isBefore(
        _ctx.localdayjs( new Date()),
        'date'
      )
    ,
          "icon-placement": "right"
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_n_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ios_arrow_back)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_n_button, {
          ghost: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateBasedate', _ctx.localdayjs( new Date()).toDate())))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_n_button, {
          ghost: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
      _ctx.$emit(
        'updateBasedate',
        _ctx.localdayjs( _ctx.theFirstDate)
          .add(_ctx.showWeek * 7, 'days')
          .toDate()
      )
    ))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_n_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ios_arrow_forward)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("table", {
      class: _normalizeClass(["timeline-table border-collapse border-gray-400 shadow-md", _ctx.tableClass])
    }, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showWeek * 7, (n, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index % 7 === 0)
              ? (_openBlock(), _createElementBlock("th", _hoisted_3, _toDisplayString(_ctx.dateHeaderFormat(
              _ctx.localdayjs( _ctx.theFirstDate).add(index, "days").toDate()
            )) + " - " + _toDisplayString(_ctx.dateHeaderFormat(
              _ctx.localdayjs( _ctx.theFirstDate)
                .add(index + 6, "days")
                .toDate()
            )), 1))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("tr", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showWeek * 7, (n, index) => {
          return (_openBlock(), _createElementBlock("th", {
            class: _normalizeClass(["timeline-colheader border border-gray-300", {
          today: _ctx.localdayjs( _ctx.theFirstDate)
            .add(index, 'days')
            .isSame(_ctx.today, 'date'),
        }]),
            key: index,
            ref_for: true,
            ref: _ctx.setItemRef
          }, _toDisplayString(_ctx.dayHeaderFormat(_ctx.localdayjs( _ctx.theFirstDate).add(index, "days").toDate())), 3))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localRowGroupHeaders, (grp) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: grp.Value
        }, [
          _createElementVNode("tr", _hoisted_5, [
            _createElementVNode("td", {
              class: "timeline-rowheader border border-t-0 border-b-0",
              onClick: ($event: any) => (grp.ShowDetail = !grp.ShowDetail)
            }, [
              _createVNode(_component_n_icon, { class: "pt-px" }, {
                default: _withCtx(() => [
                  (grp.ShowDetail)
                    ? (_openBlock(), _createBlock(_component_ios_arrow_down, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_ios_arrow_forward, { key: 1 }))
                ]),
                _: 2
              }, 1024),
              _createElementVNode("span", _hoisted_7, _toDisplayString(grp.Text), 1)
            ], 8, _hoisted_6),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showWeek * 7, (n, index) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass(["border border-t-0 border-b-0", {
            today: _ctx.localdayjs( _ctx.theFirstDate)
              .add(index, 'days')
              .isSame(_ctx.today, 'date'),
          }]),
                key: index
              }, null, 2))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowHeaders.filter((r) => r.Group == grp.Value), (row) => {
            return _withDirectives((_openBlock(), _createElementBlock("tr", {
              class: "timeline-row timeline-row-hover cursor-pointer w-1",
              key: row.Value,
              onClick: ($event: any) => (_ctx.$emit('clickRow', row.Value))
            }, [
              _createElementVNode("td", {
                class: "timeline-rowheader border border-t-0 border-b-0 w-1/6 relative",
                id: row.Value
              }, [
                _createVNode(_component_n_icon, { class: "pt-px" }),
                _createElementVNode("span", {
                  class: "timeline-dot absolute left-5 top-3 right-0 truncate",
                  style: _normalizeStyle({ backgroundColor: _ctx.stringColor(row.StyleColor, false) })
                }, null, 4),
                _createElementVNode("span", _hoisted_10, _toDisplayString(row.Text), 1)
              ], 8, _hoisted_9),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showWeek * 7, (n, colidx) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass(["border border-t-0 border-b-0 border-gray-300", {
            today: _ctx.localdayjs( _ctx.theFirstDate)
              .add(colidx, 'days')
              .isSame(_ctx.today, 'date'),
          }]),
                  key: colidx
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData, (render, eventidx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: eventidx }, [
                      (
                render.hasOwnProperty(row.Value) &&
                render[row.Value].hasOwnProperty(colidx)
              )
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(render[row.Value][colidx], (item, itemkey, itemindex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: itemindex,
                              class: _normalizeClass(["timeline-event", {
                    'timeline-event-start': !item.isBefore,
                    'timeline-event-end': !item.isAfter,
                  }]),
                              style: _normalizeStyle({
                    width: _ctx.eventWidth(item.length),
                    backgroundColor: _ctx.stringColor(row.StyleColor, item.isAlpha),
                  })
                            }, null, 6))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 2))
              }), 128))
            ], 8, _hoisted_8)), [
              [_vShow, grp.ShowDetail]
            ])
          }), 128))
        ], 64))
      }), 128))
    ], 2)
  ], 64))
}